import type { TCurrency } from 'api/swagger';
import { CURRENCY_SIGN, ECurrency } from 'types/currencies';

export const isDefaultCurrency = (currency: TCurrency) => currency === ECurrency.EUR;

export const formatPriceInDefault = (price: number, priceInDefault: number, currency: TCurrency) =>
  isDefaultCurrency(currency)
    ? `${price} ${CURRENCY_SIGN[ECurrency.EUR]}`
    : `≈ ${priceInDefault} ${CURRENCY_SIGN[ECurrency.EUR]}`;

export const formatPriceInOriginalCurrency = (price: number, currency: TCurrency) =>
  `${price} ${CURRENCY_SIGN[currency]}`;
